import { render, staticRenderFns } from "./zxDtGk.vue?vue&type=template&id=775f34ce&scoped=true&"
import script from "./zxDtGk.vue?vue&type=script&lang=js&"
export * from "./zxDtGk.vue?vue&type=script&lang=js&"
import style0 from "./zxDtGk.vue?vue&type=style&index=0&id=775f34ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f34ce",
  null
  
)

export default component.exports